export default {
  'logo.name': 'BasetaoSheet',
  'logo.tagline': 'Spreadsheet Resource Hub',

  'meta.title': 'Basetao Spreadsheet: Products, Sellers & Buying Guides',
  'meta.description': 'Explore Basetao Spreadsheet resources, product finds, seller guides, QC tips, shipping information, reviews and practical buying guides.',

  'nav.spreadsheet': 'Spreadsheet',
  'nav.home': 'Home',
  'nav.guide': 'Shopping Guide',
  'nav.guides': 'Guides',
  'nav.products': 'Products',
  'nav.sellers': 'Sellers',
  'nav.qc': 'QC',
  'nav.shipping': 'Shipping',
  'nav.reviews': 'Reviews',
  'nav.safety': 'Safety',
  'nav.cta': 'Explore Spreadsheet',

  'hero.eyebrow': 'THE BASETAO SPREADSHEET RESOURCE HUB',
  'hero.title': 'Basetao Spreadsheet — Find Products, Sellers & Buying Guides Faster',
  'hero.subtitle': 'Explore organized Basetao spreadsheet resources, product finds, seller information, QC guides, shipping tips and practical buying tutorials — all in one place.',
  'hero.ctaPrimary': 'Basetao Spreadsheet',
  'hero.ctaSecondary': 'Buy It Now',
  'hero.dropdownLabel': 'Browse a category',
  'hero.dropdownPlaceholder': 'Choose a product category…',
  'hero.trust': 'Independent resource · Updated guides · Product & seller research · QC & shipping education',

  'value.title': 'Everything You Need to Navigate Basetao',
  'value.subtitle': 'A clear, organized starting point for smarter product discovery.',
  'value.c1.title': 'Basetao Spreadsheet',
  'value.c1.desc': 'Discover organized spreadsheet resources and learn how to evaluate product and seller information.',
  'value.c2.title': 'Product & Seller Guides',
  'value.c2.desc': 'Compare products, sellers, prices and the important signals that matter before you order.',
  'value.c3.title': 'QC & Quality Checks',
  'value.c3.desc': 'Understand QC photos, common quality indicators and what to verify before ordering.',
  'value.c4.title': 'Shipping & Safety',
  'value.c4.desc': 'Compare shipping options and costs, and learn how to spot risks and suspicious listings.',

  'categories.title': 'Browse Product Categories',
  'categories.subtitle': 'Jump straight to a category on the main store and start exploring organized finds.',
  'categories.open': 'Open category',

  'about.eyebrow': 'WHAT IS A BASETAO SPREADSHEET?',
  'about.title': 'A Smarter Way to Find Products & Sellers',
  'about.body1': 'A Basetao spreadsheet is a shared, organized document that collects product links, seller details, prices and notes gathered from the Basetao buying-agent ecosystem. Instead of scrolling through endless listings, shoppers use these spreadsheets to compare options side by side and understand exactly what they are buying.',
  'about.body2': 'Most spreadsheets are organized by category — shoes, hoodies, t-shirts, jackets, bags and more — and each row typically points to a product or seller with extra context such as price, sizing notes and QC remarks.',
  'about.body3': 'Because these documents are updated regularly, they are a practical shortcut for anyone who wants to discover new items and trusted sellers without spending hours digging through marketplaces.',
  'about.list1': 'Curated product links',
  'about.list2': 'Seller & price signals',
  'about.list3': 'Regular updates',

  'how.title': 'How to Use a Basetao Spreadsheet',
  'how.subtitle': 'Four simple steps to get real value from any spreadsheet.',
  'how.s1.title': 'Discover',
  'how.s1.desc': 'Find relevant products and categories that match what you are looking for.',
  'how.s2.title': 'Compare',
  'how.s2.desc': 'Review product, seller and pricing information side by side.',
  'how.s3.title': 'Verify',
  'how.s3.desc': 'Check links, seller signals and any available QC information.',
  'how.s4.title': 'Decide',
  'how.s4.desc': 'Use the information to make your own informed decision.',

  'topics.title': 'Popular Basetao Resources',
  'topics.subtitle': 'Guides and resources to help you buy with more confidence.',
  'topics.cardTitle': 'Basetao Spreadsheet Guide',
  'topics.cardDesc': 'Learn what a Basetao spreadsheet is, how to read it, and how to use it to find better products and sellers.',
  'topics.readMore': 'Read the guide',
  'topics.moreComing': 'More guides coming soon',
  'guide.notFound': 'This guide could not be found.',

  'faq.title': 'Basetao Spreadsheet FAQ',
  'faq.q1': 'What is a Basetao spreadsheet?',
  'faq.a1': 'It is an organized document that collects product links, seller information, prices and notes from the Basetao ecosystem, so shoppers can compare and discover items more easily.',
  'faq.q2': 'Is the spreadsheet free to use?',
  'faq.a2': 'Spreadsheet resources are informational. Always check the source and verify any links before making a purchase.',
  'faq.q3': 'How often is the spreadsheet updated?',
  'faq.a3': 'Update frequency depends on the source. Reliable spreadsheets tend to be refreshed regularly as new products and sellers are added.',
  'faq.q4': 'Can I trust every seller listed?',
  'faq.a4': 'No resource can guarantee a seller. Use multiple signals — reviews, QC photos and shipping info — before you decide.',
  'faq.q5': 'What categories are usually included?',
  'faq.a5': 'Common categories include shoes, hoodies, t-shirts, jackets, pants, headwear, sets, underwear, jerseys, accessories, bags, belts, perfumes and more.',

  'cta.title': 'Ready to Explore Basetao Spreadsheet Resources?',
  'cta.subtitle': 'Browse the latest guides, product resources and buying information in one organized hub.',
  'cta.button': 'Explore Basetao Spreadsheet',

  'footer.tagline': 'An independent resource hub for Basetao spreadsheet guides, product finds and buying information.',
  'footer.disclaimer': 'This website is an independent informational resource. It is not affiliated with or endorsed by Basetao.',
  'footer.navTitle': 'Explore',
  'footer.resourceTitle': 'Resources',
  'footer.copyright': 'All rights reserved.',

  'cat.shoes': 'Shoes',
  'cat.hoodies': 'Hoodies / Sweaters',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jackets',
  'cat.pants': 'Pants / Shorts',
  'cat.headwear': 'Headwear',
  'cat.sets': 'Sets',
  'cat.underwear': 'Underwear / Underpants',
  'cat.jersey': 'Jersey',
  'cat.accessories': 'Accessories',
  'cat.bags': 'Bags',
  'cat.belts': 'Belts',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Other Stuff',
};